import { useFormikContext } from 'formik';
import { ReleaseIdCard, AccordionControlData } from 'front-office/view-models/release-id-card';
import { useState } from 'react';
import DocumentForm from './document';
import RegistryOfficeForm from './registry-office';
import ResidenceForm from './residence';
import OtherDataForm from './other-data';
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, List, Typography, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import ControlDataForm from './control-data-form';
import AccordionPersonForm from './accordion-person-form';

const ReleaseIdCardForm = (): React.ReactElement => {
  const formContext = useFormikContext<ReleaseIdCard>();

  const [openPerson, setOpenPerson] = useState(true);
  const [openControlData, setOpenControlData] = useState(true);

  const onChangeControlData = useEventCallback(
    (key: keyof AccordionControlData, value: AccordionControlData[keyof AccordionControlData]) => {
      const newControlData = {
        ...formContext.values.controlData,
        [key]: value,
      };

      formContext.setFieldValue('controlData', newControlData);
    }
  );

  const onClear = useEventCallback(() => {
    formContext.resetForm();
    formContext.validateForm();
  });

  return (
    <List style={{ overflow: 'auto', minHeight: '100%' }}>
      <Accordion
        expanded={openPerson}
        onChange={() => {
          setOpenPerson(!openPerson);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Persona</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionPersonForm
            disabled
            values={formContext.values.person || null}
            generality={formContext.values.registryOffice?.generality}
            citizenship={formContext.values.registryOffice?.citizenship}
            family={formContext.values.family}
            onChange={formContext.handleChange}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={openControlData}
        onChange={() => {
          setOpenControlData(!openControlData);
        }}
      >
        <AccordionSummary
          aria-controls="panel-control-data-content"
          id="panel-control-data-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Dati di controllo modifica</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ControlDataForm
            onChange={onChangeControlData}
            values={formContext.values?.controlData as AccordionControlData}
          />
        </AccordionDetails>
      </Accordion>
      {formContext.values.isRegistryOffice ? <RegistryOfficeForm /> : undefined}
      {formContext.values.isResidence ? <ResidenceForm /> : undefined}
      {formContext.values.isDocument ? <DocumentForm /> : undefined}
      {formContext.values.isOtherData ? <OtherDataForm /> : undefined}
      <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
        <PmiButton variant="outlined" color="cdmBrand" onClick={onClear}>
          Ripulisci
        </PmiButton>
      </div>
    </List>
  );
};

ReleaseIdCardForm.displayName = 'Release id card form component';

export default ReleaseIdCardForm;
